/* eslint-disable */
// Generated by scripts/postgen.mjs from backend/api/v2.openapi.yaml. Do not edit manually.

/** Every `x-problem-codes` key: the snake_case form of a problem `type`'s last segment (DW-02). */
export const PROBLEM_CODES = [
  "account_disabled",
  "adjustment_conflict",
  "amount_out_of_range",
  "authentication_required",
  "banned_required",
  "batch_not_found",
  "batch_not_listed",
  "billing_provider_local",
  "blank_message",
  "callback_rejected",
  "credit_note_not_found",
  "customer_permission_not_allowed",
  "deletion_already_requested",
  "delivery_host_not_allowed",
  "delivery_not_found",
  "delivery_not_retryable",
  "delivery_url_not_https",
  "delivery_url_scheme",
  "device_limit_reached",
  "device_not_enabled",
  "device_not_exist",
  "device_not_found",
  "device_not_listed",
  "email_not_verified",
  "email_taken",
  "enabled_required",
  "expires_at_required",
  "google_token_invalid",
  "idempotency_in_flight",
  "idempotency_key_invalid",
  "idempotency_key_required",
  "idempotency_key_reuse",
  "idempotency_lock_lost",
  "idempotency_response_unavailable",
  "illegal_transition",
  "insufficient_funds",
  "internal_error",
  "invalid_adjustment",
  "invalid_amount",
  "invalid_body",
  "invalid_category",
  "invalid_credentials",
  "invalid_cursor",
  "invalid_custom_limit",
  "invalid_custom_range",
  "invalid_day",
  "invalid_delivery_url",
  "invalid_device_id",
  "invalid_effect",
  "invalid_email",
  "invalid_email_preferences",
  "invalid_event",
  "invalid_filter",
  "invalid_id",
  "invalid_interval",
  "invalid_key",
  "invalid_message_list",
  "invalid_message_query",
  "invalid_name",
  "invalid_overage_cap",
  "invalid_page",
  "invalid_plan",
  "invalid_price_version",
  "invalid_profile",
  "invalid_range",
  "invalid_reason",
  "invalid_recipients",
  "invalid_recurring_interval",
  "invalid_role_input",
  "invalid_schedule",
  "invalid_setting",
  "invalid_signing_secret",
  "invalid_status",
  "invalid_subscription_id",
  "invalid_user_id",
  "invite_requires_staff_role",
  "invoice_not_found",
  "invoice_not_paid",
  "invoice_paid",
  "invoice_void",
  "job_not_discarded",
  "job_not_found",
  "job_superseded",
  "last_super_admin",
  "limit_exceeded",
  "malformed_received_sms",
  "message_required",
  "message_too_long",
  "method_unavailable",
  "msisdn_invalid",
  "name_control_chars",
  "name_required",
  "name_too_long",
  "no_enabled_device",
  "no_events",
  "not_found",
  "not_revoked",
  "nothing_to_change",
  "notice_finished",
  "otp_invalid",
  "overage_pack_closed",
  "override_not_found",
  "page_not_found",
  "page_version_conflict",
  "password_hash_busy",
  "payload_too_large",
  "payment_already_credited",
  "payment_amount_mismatch",
  "payment_creditable",
  "payment_exists",
  "payment_initiation_in_progress",
  "payment_needs_review",
  "payment_not_expired",
  "payment_not_found",
  "payment_not_in_review",
  "permission_denied",
  "phone_control_chars",
  "phone_too_long",
  "plan_already_active",
  "plan_id_required",
  "plan_inactive",
  "plan_name_locked",
  "plan_name_taken",
  "plan_not_for_sale",
  "plan_not_found",
  "plan_required",
  "polled_too_recently",
  "price_version_not_found",
  "privilege_escalation",
  "proof_invalid",
  "provider_unavailable",
  "quote_not_found",
  "quote_plan_mismatch",
  "quote_stale",
  "rate_limited",
  "reason_required",
  "reassign_to_self",
  "reconciliation_report_not_found",
  "recovery_off",
  "recovery_old_version",
  "refresh_reused",
  "refund_destination_invalid",
  "refund_fee_invalid",
  "refund_not_found",
  "refund_out_of_range",
  "refund_pending",
  "refund_reviewed",
  "report_not_found",
  "request_invalid",
  "reserved_plan_name",
  "role_in_use",
  "role_is_system",
  "role_not_found",
  "role_slug_taken",
  "schedule_in_past",
  "service_unavailable",
  "session_invalid",
  "session_not_found",
  "setting_not_found",
  "setting_version_conflict",
  "sms_not_found",
  "sms_other_device",
  "staff_account_override",
  "standalone_disabled",
  "stats_bucket",
  "stats_range",
  "step_up_required",
  "subscription_active_wallet",
  "subscription_not_found",
  "super_admin_override",
  "token_invalid",
  "too_many_emails",
  "too_many_recipients",
  "topup_closed",
  "topup_not_found",
  "topup_rate_limited",
  "totp_enrolment_required",
  "totp_invalid",
  "totp_required_for_staff",
  "transfer_expired",
  "transfer_not_found",
  "transfer_not_submitted",
  "transfer_overpaid",
  "transfer_reviewed",
  "turnstile_failed",
  "unauthorized",
  "unknown_permission",
  "user_deleted",
  "user_not_found",
  "weak_password",
  "webhook_limit",
] as const

/** Every operation marked `x-idempotency: required`; the caller must send an `Idempotency-Key`. */
export const IDEMPOTENT_OPERATIONS = [
  { operationId: "adminAdjustUserWallet", method: "POST", path: "/admin/users/{id}/wallet/adjustments" },
  { operationId: "adminApproveTransfer", method: "POST", path: "/admin/transfers/{id}/approve" },
  { operationId: "adminCreatePlan", method: "POST", path: "/admin/plans" },
  { operationId: "adminPayoutRefund", method: "POST", path: "/admin/refunds/{id}/payout" },
  { operationId: "adminPutSetting", method: "PUT", path: "/admin/settings/{key}" },
  { operationId: "adminResolvePayment", method: "POST", path: "/admin/payments/{id}/resolve" },
  { operationId: "adminRetryJob", method: "POST", path: "/admin/jobs/{id}/retry" },
  { operationId: "adminSavePage", method: "PUT", path: "/admin/pages/{slug}" },
  { operationId: "adminUpdatePlan", method: "PATCH", path: "/admin/plans/{planId}" },
  { operationId: "createTopup", method: "POST", path: "/topups" },
  { operationId: "createTransfer", method: "POST", path: "/transfers" },
  { operationId: "purchasePlan", method: "POST", path: "/plans/{planId}/purchase" },
  { operationId: "requestRefund", method: "POST", path: "/refunds" },
] as const

/** Every operation marked `x-step-up: true`; the caller must send a live `X-Step-Up` (LLD §6.7). */
export const STEP_UP_OPERATIONS: readonly string[] = [
  "adminAdjustUserWallet",
  "adminApproveTransfer",
  "adminClearUserPermission",
  "adminCreatePlan",
  "adminCreateRole",
  "adminDeleteRole",
  "adminDeleteUser",
  "adminExportVat",
  "adminInviteStaff",
  "adminPayoutRefund",
  "adminPublishPriceVersion",
  "adminPutSetting",
  "adminResolvePayment",
  "adminRetryJob",
  "adminSavePage",
  "adminSetUserBanned",
  "adminSetUserLimits",
  "adminSetUserPermission",
  "adminSetUserRole",
  "adminSetUserSubscription",
  "adminUpdatePlan",
  "adminUpdateRole",
  "beginTotpEnrolment",
  "changePassword",
  "confirmTotpEnrolment",
  "disableTotp",
]

/** Each operation's `x-permission`; a list means every one is required (LLD §6.5). */
export const OPERATION_PERMISSIONS: Readonly<Record<string, readonly string[]>> = {
  adminAdjustUserWallet: ["wallet.adjustment:create"],
  adminApproveRefund: ["refunds.refund:review"],
  adminApproveTransfer: ["transfers.transfer:review"],
  adminClearUserPermission: ["identity.permission:grant"],
  adminCreatePlan: ["billing.plan:write"],
  adminCreateRole: ["identity.role:write"],
  adminDeleteRole: ["identity.role:delete"],
  adminDeleteUser: ["identity.user:delete"],
  adminEnableWebhook: ["webhooks.any:write"],
  adminExportPlans: ["reports.report:read"],
  adminExportRefunds: ["reports.report:read","invoices.any:read"],
  adminExportTopups: ["reports.report:read","invoices.any:read"],
  adminExportVat: ["reports.report:read","reports.vat:export"],
  adminGetCreditNotePdf: ["refunds.refund:review"],
  adminGetJob: ["system.job:read"],
  adminGetOverview: ["reports.report:read"],
  adminGetPage: ["content.page:write"],
  adminGetPageVersion: ["content.page:write"],
  adminGetPayment: ["payments.payment:read"],
  adminGetReconciliation: ["ledger.reconciliation:read"],
  adminGetRefund: ["refunds.refund:review"],
  adminGetRole: ["identity.role:read"],
  adminGetSetting: ["settings.app:read"],
  adminGetSystemStatus: ["system.status:read"],
  adminGetTransfer: ["transfers.transfer:review"],
  adminGetUser: ["identity.user:read"],
  adminGetUserSubscription: ["billing.subscription:write"],
  adminGetUserWallet: ["ledger.journal:read"],
  adminInviteStaff: ["identity.staff:invite"],
  adminListAudit: ["audit.log:read"],
  adminListDevices: ["devices.any:read"],
  adminListJobs: ["system.job:read"],
  adminListMessages: ["messaging.any:read"],
  adminListPages: ["content.page:write"],
  adminListPayments: ["payments.payment:read"],
  adminListPaymentsToReview: ["payments.payment:read"],
  adminListPermissions: ["identity.role:read"],
  adminListPlans: ["billing.plan:write"],
  adminListPriceVersions: ["pricing.price:write"],
  adminListRefunds: ["refunds.refund:review"],
  adminListRoles: ["identity.role:read"],
  adminListSettings: ["settings.app:read"],
  adminListTransfers: ["transfers.transfer:review"],
  adminListUsers: ["identity.user:read"],
  adminListWebhookDeliveries: ["webhooks.any:read"],
  adminListWebhooks: ["webhooks.any:read"],
  adminPayoutRefund: ["refunds.refund:review","refunds.refund:payout","invoices.credit_note:issue"],
  adminPublishPriceVersion: ["pricing.price:write"],
  adminPutSetting: ["settings.app:write"],
  adminReconcilePayment: ["payments.payment:reconcile"],
  adminRejectRefund: ["refunds.refund:review"],
  adminRejectTransfer: ["transfers.transfer:review"],
  adminResolvePayment: ["payments.payment:resolve"],
  adminRetryJob: ["system.job:retry"],
  adminRetryWebhookDelivery: ["webhooks.any:write"],
  adminRunReconciliation: ["ledger.reconciliation:read","wallet.adjustment:create"],
  adminSavePage: ["content.page:write"],
  adminSetUserBanned: ["identity.user:ban"],
  adminSetUserLimits: ["billing.limit:override"],
  adminSetUserPermission: ["identity.permission:grant"],
  adminSetUserRole: ["identity.user:write"],
  adminSetUserSubscription: ["billing.subscription:write"],
  adminUpdateDevice: ["devices.any:write"],
  adminUpdatePlan: ["billing.plan:write"],
  adminUpdateRole: ["identity.role:write"],
  beginTotpEnrolment: ["account.security:manage"],
  cancelRefund: ["refunds.request:create"],
  changePassword: ["account.security:manage"],
  confirmTotpEnrolment: ["account.security:manage"],
  contactSupport: ["account.profile:write"],
  createApiKey: ["apikeys.key:manage"],
  createTopup: ["wallet.topup:create"],
  createTransfer: ["wallet.topup:create"],
  createWebhook: ["webhooks.subscription:manage"],
  deleteApiKey: ["apikeys.key:manage"],
  deleteDevice: ["devices.device:write"],
  deleteWebhook: ["webhooks.subscription:manage"],
  disableTotp: ["account.security:manage"],
  getBatch: ["messaging.sms:read"],
  getCreditNotePdf: ["invoices.document:read"],
  getDevice: ["devices.device:read"],
  getEmailPreferences: ["account.profile:read"],
  getInvoicePdf: ["invoices.document:read"],
  getMessage: ["messaging.sms:read"],
  getMessageStats: ["messaging.sms:read"],
  getOverage: ["billing.subscription:read"],
  getOverview: ["account.profile:read"],
  getProfile: ["account.profile:read"],
  getSubscription: ["billing.subscription:read"],
  getTopup: ["wallet.balance:read"],
  getTransfer: ["wallet.balance:read"],
  getWallet: ["wallet.balance:read"],
  getWebhook: ["webhooks.subscription:manage"],
  listApiKeys: ["apikeys.key:manage"],
  listDevices: ["devices.device:read"],
  listInvoices: ["invoices.document:read"],
  listMessages: ["messaging.sms:read"],
  listOveragePacks: ["billing.subscription:read"],
  listRefunds: ["wallet.balance:read"],
  listSessions: ["account.security:manage"],
  listTopups: ["wallet.balance:read"],
  listWalletJournal: ["wallet.balance:read"],
  listWebhookDeliveries: ["webhooks.subscription:manage"],
  listWebhooks: ["webhooks.subscription:manage"],
  purchasePlan: ["billing.plan:purchase"],
  quotePlan: ["billing.subscription:read"],
  quoteRefund: ["wallet.balance:read"],
  renameApiKey: ["apikeys.key:manage"],
  renewTransferUpload: ["wallet.topup:create"],
  requestAccountDeletion: ["account.profile:write"],
  requestRefund: ["refunds.request:create"],
  revokeApiKey: ["apikeys.key:manage"],
  revokeSession: ["account.security:manage"],
  sendMessages: ["messaging.sms:send"],
  setDefaultDevice: ["devices.device:write"],
  setEmailPreferences: ["account.profile:write"],
  submitTransfer: ["wallet.topup:create"],
  testWebhook: ["webhooks.subscription:manage"],
  updateDevice: ["devices.device:write"],
  updateOverage: ["billing.plan:purchase"],
  updateProfile: ["account.profile:write"],
  updateSubscription: ["billing.plan:purchase"],
  updateWebhook: ["webhooks.subscription:manage"],
}
